import gql from 'graphql-tag';

/** Donation eligibility query for donation flows. */
export const CHECK_DONATION_ELIGIBILITY_QUERY = gql`
  query CheckDonationEligibility($token: String!) {
    checkoutSession(token: $token) {
      donationEligibility {
        isSenderEligible
        ineligibilityReason
      }
    }
  }
`;
